import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const TimerComponent = ({ initialTime }) => {
  const [remainingTime, setRemainingTime] = useState(initialTime);
  const { t } = useTranslation();

  useEffect(() => {
    // Function to decrement the timer
    const decrementTime = () => {
      setRemainingTime((prevTime) => {
        let { day, hour, minute, second } = prevTime;

        if (second > 0) {
          second -= 1;
        } else {
          if (minute > 0) {
            minute -= 1;
            second = 59; // Reset seconds to 59
          } else {
            if (hour > 0) {
              hour -= 1;
              minute = 59; // Reset minutes to 59
              second = 59; // Reset seconds to 59
            } else {
              if (day > 0) {
                day -= 1;
                hour = 23; // Reset hours to 23
                minute = 59; // Reset minutes to 59
                second = 59; // Reset seconds to 59
              }
            }
          }
        }

        // If all time is zero, stop the timer
        if (day === 0 && hour === 0 && minute === 0 && second === 0) {
          clearInterval(interval);
        }

        return { day, hour, minute, second };
      });
    };

    const interval = setInterval(decrementTime, 1000); // Update every second

    return () => {
      clearInterval(interval); // Clean up the interval on unmount
    };
  }, []);

  // Helper function to format time values as two digits and split into an array
  const formatAndSplitTime = (time: number) => {
    return time.toString().padStart(2, "0").split("");
  };
  const renderTimer = () => {
    const [day1, day2] = formatAndSplitTime(remainingTime.day);
    const [hour1, hour2] = formatAndSplitTime(remainingTime.hour);
    const [minute1, minute2] = formatAndSplitTime(remainingTime.minute);
    const [second1, second2] = formatAndSplitTime(remainingTime.second);
    return (
      <div className="relative w-[93%] mt-2 mx-auto">
        <div className="flex flex-row gap-2 mx-auto w-full bg-transparent relative py-1  px-2 z-20 justify-around ">
          <div className=" flex flex-row w-[80%]  justify-between items-center">
            <div className="flex flex-col  w-[20%] justify-between items-center ">
              <div className="flex flex-row w-full gap-1 justify-center">
                <span className="text-[#FFFFFFCC] PkNumbers text-center pt-1 font-inter font-semibold text-[16px]  tracking-normal  rounded-[1px]">
                  {day1}
                </span>
                <span className="text-[#FFFFFFCC] PkNumbers text-center pt-1 font-inter font-semibold text-[16px]  tracking-normal  rounded-[1px]">
                  {day2}
                </span>
              </div>
              <span className="Timetext mx-1 font-inter font-semibold text-[16px] leading-[24px] tracking-normal">
                D
              </span>
            </div>

            <div className="flex flex-col w-[20%] justify-between items-center ">
              <div className="flex flex-row w-full gap-1 justify-center">
                <span className="text-[#FFFFFFCC]  PkNumbers text-center pt-1 font-inter font-semibold text-[16px]  tracking-normal  rounded-[1px]">
                  {hour1}
                </span>{" "}
                <span className="text-[#FFFFFFCC]  PkNumbers text-center pt-1 font-inter font-semibold text-[16px]  tracking-normal  rounded-[1px]">
                  {hour2}
                </span>
              </div>
              <span className="Timetext mx-1 font-inter font-semibold text-[16px] leading-[24px] tracking-normal">
                H{" "}
              </span>
            </div>

            <div className="flex flex-col w-[20%] justify-between items-center ">
              <div className="flex flex-row gap-1 w-full justify-center">
                <span className="text-[#FFFFFFCC]  PkNumbers text-center pt-1 font-inter font-semibold text-[16px]  tracking-normal  rounded-[1px]">
                  {minute1}
                </span>{" "}
                <span className="text-[#FFFFFFCC]  PkNumbers text-center pt-1 font-inter font-semibold text-[16px]  tracking-normal  rounded-[1px]">
                  {minute2}
                </span>
              </div>
              <span className="Timetext mx-1 font-inter font-semibold text-[16px] leading-[24px] tracking-normal">
                M{" "}
              </span>
            </div>

            <div className="flex flex-col w-[20%] justify-between items-center ">
              <div className="flex flex-row gap-1 w-full justify-center">
                <span className="text-[#FFFFFFCC]  PkNumbers text-center pt-1 font-inter font-semibold text-[16px]  tracking-normal  rounded-[1px]">
                  {second1}
                </span>
                <span className="text-[#FFFFFFCC]  PkNumbers text-center pt-1 font-inter font-semibold text-[16px]  tracking-normal  rounded-[1px]">
                  {second2}
                </span>
              </div>
              <span className="Timetext mx-1 font-inter font-semibold text-[16px] leading-[24px] tracking-normal">
                S{" "}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return renderTimer();
};

export default TimerComponent;
